module.exports = __webpack_public_path__ + "img/1550512048.21e028cb.jpg";